import React, { Component } from 'react'

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="footerMail">
          <a
            onMouseEnter={() => this.props.runOnEnter()}
            onMouseLeave={() => {
              this.props.runOnLeave();
            }}
            href="mailto:himanshuratnani1996@gmail.com"
          >
            himanshuratnani1996@gmail.com
          </a>
        </div>
        <div className="social">
          <ul className="social_links">
            {/* <li>
              <a
                href=""
                onMouseEnter={() => this.props.runOnEnter()}
                onMouseLeave={() => {
                  this.props.runOnLeave();
                }}
              >
                <i className="fa fa-facebook fa-lg" aria-hidden="true" />
              </a>
            </li> */}
            <li>
              <a
                target="_blank"
                href="https://www.linkedin.com/in/himanshuratnani/"
                onMouseEnter={() => this.props.runOnEnter()}
                onMouseLeave={() => {
                  this.props.runOnLeave();
                }}
              >
                <i className="fa fa-linkedin fa-lg" aria-hidden="true" />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://github.com/ratnani1996"
                onMouseEnter={() => this.props.runOnEnter()}
                onMouseLeave={() => {
                  this.props.runOnLeave();
                }}
              >
                <i className="fa fa-code-fork fa-lg" aria-hidden="true" />
              </a>
            </li>
            {/* <li>
              <a
                href=""
                onMouseEnter={() => this.props.runOnEnter()}
                onMouseLeave={() => {
                  this.props.runOnLeave();
                }}
              >
                <i className="fa fa-instagram fa-lg" aria-hidden="true" />
              </a>
            </li> */}
          </ul>
        </div>
      </footer>
    );
  }
}
